export default __webpack_public_path__ + "static/media/bucket.e8ab8483.svg";